import { getPageUiStates } from 'shared/lib/api';
import {
  type ContractorCampaignModel,
  useGetCampaigns,
  useGetCampaignContractorFilter,
  ContractorCampaignsFilter,
} from 'entities/campaign';
import { Loader } from 'shared/ui/Loader';
import { InfoBox } from 'shared/ui/InfoBox';
import { PageError } from 'shared/ui/PageError';

import { ContractorCampaignsTable } from './ContractorCampaignsTable';
import { Filters } from './Filters';

interface ContractorCampaignsOverbudgetProps {
  onTableRowClick: ({ id }: { id: number }) => void;
}
const initialSort = { [ContractorCampaignsFilter.percent80]: '80' };

export function ContractorCampaignsOverbudget({ onTableRowClick }: ContractorCampaignsOverbudgetProps) {
  const filtersFromURL = useGetCampaignContractorFilter(initialSort);

  const getCampaignsQuery = useGetCampaigns<ContractorCampaignModel>({ urlFilters: filtersFromURL });
  const pageStates = getPageUiStates([getCampaignsQuery]);

  if (pageStates.isTableLoading) {
    return <Loader className="mt-20 flex justify-center" />;
  }

  return (
    <>
      <Filters />
      {pageStates.isEmptyResponse && !pageStates.hasErrors && (
        <InfoBox
          className="mt-6"
          title="⏳ No overbudget campaigns at the moment"
          text="This section will display all campaigns that have exceeded their budgets."
        />
      )}
      {pageStates.hasErrors && (
        <div className="mt-6">
          <PageError />
        </div>
      )}
      {!pageStates.hasErrors && !pageStates.isEmptyResponse && (
        <ContractorCampaignsTable
          data={getCampaignsQuery.data}
          isLoading={pageStates.isTableFetching}
          onTableRowClick={onTableRowClick}
        />
      )}
    </>
  );
}
